import type { Meta, StoryFn } from '@storybook/react';

import { CommaSeparatedList } from '@pega/cosmos-react-core';
import type { CommaSeparatedListProps, OmitStrict } from '@pega/cosmos-react-core';

export default {
  title: 'Core/List',
  component: CommaSeparatedList
} as Meta;

export const CommaSeparatedListDemo: StoryFn<OmitStrict<CommaSeparatedListProps, 'items'>> = (
  args: OmitStrict<CommaSeparatedListProps, 'items'>
) => {
  const items = [
    'Value 1',
    'Value 2',
    'Value 3',
    'Value 4',
    'Value 5',
    'Value 6',
    'Value 7',
    'Value 8',
    'Value 9',
    'Value 10',
    'Value 11',
    'Value 12',
    'Value 13',
    'Value 14'
  ];

  return <CommaSeparatedList heading={args.heading} items={items} />;
};

CommaSeparatedListDemo.args = {
  heading: 'List Heading'
};

CommaSeparatedListDemo.argTypes = {
  heading: { control: { type: 'text' } }
};
